module.exports = __webpack_public_path__ + "static/media/right3.e078e01b.png";